








import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class Retour extends Vue {
    // Prop => Data envoyée depuis le composent parent à l'enfant (ici l'étape courante)
    @Prop() private step!: number
    // Ajoute un evenement "OnClick" sur le boutons pour aller à la vue précédente
    private addEventInbtn () : void {
      const button = document.querySelector('.btn-retour')
      if (button) {
        button.addEventListener('click', (event) => {
          if (event) {
            this.choiseRoutesToReturn()
          }
        }, false)
      }
    }

    private choiseRoutesToReturn (): void {
      if (this.step) {
        const prevStep = this.step - 1
        const castPrevStep = prevStep as unknown
        const value = castPrevStep as string
        this.$router.push({ name: 'Etape' + value })
      }
    }

    mounted (): void {
      this.addEventInbtn()
    }
}
